import { Markdown, Themes } from '@mgmresorts/markdown';
import { Icon } from '@mgmresorts/mgm-ui';
import React, { AriaRole, ReactElement, useEffect, useRef } from 'react';

import { StyledContainer, StyledIconWrapper, StyledTypography } from './Alert.styles';

export const Alert = (props: {
  text: string;
  type?: 'error' | 'info';
  children?: ReactElement;
  testId?: string;
  role?: AriaRole;
}) => {
  const { type = 'error', testId, ...rest } = props;
  const ref: React.RefObject<HTMLInputElement> = useRef(null);

  useEffect(() => {
    window.scroll({
      top: calculateTop(ref.current?.offsetTop),
      behavior: 'smooth',
    });
  }, []);

  return (
    <StyledContainer className={type} ref={ref} data-testid={testId} {...rest}>
      <StyledIconWrapper>
        <Icon name='exclamation-point-octagon' variant='outlined' size='small' role='img' />
      </StyledIconWrapper>
      {props.children ? (
        <StyledTypography variant='body-medium-m'>
          {props.text}
          {props.children}
        </StyledTypography>
      ) : (
        <Markdown theme={Themes.VEGA}>{props.text}</Markdown>
      )}
    </StyledContainer>
  );
};

function calculateTop(offsetTop?: number): number {
  return offsetTop ? offsetTop - 100 : 0;
}
